export class SettingsList {
    constructor(settings) {
        this.map = {};
        for (const setting of settings) {
            this.map[setting.name] = setting;
        }
    }
    getSettingValue(settingName, defaultValue) {
        const settingData = this.map[settingName.value];
        return (settingData === null || settingData === void 0 ? void 0 : settingData.value) || defaultValue;
    }
}
